<template>
<div>
    <div class="ml-4 rounded  border w-2/5 pb-8 md:w-full md:border-0">
        <div class="w-4/5 m-auto pt-8 md:w-full">
            <p class="text-blue-700">Deduction</p>
            <p class="text-gray-500 text-sm ">Change Deduction </p>

            <div class="mt-10">
                <div>
                    <div class="mt-6">
                        <label for="new-deduction" class="text-blue-700">Set Deduction(%)</label><br>
                        <input class="border-2 mt-3 w-full rounded-lg p-3 text-sm" type="text" name="new-deduction" id="new-deduction" placeholder="Deduction(%)" v-model="deduction">
                        <p v-if="deductionValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                    </div>
                    <div class="mt-10 flex">
                        <button @click="updateDeduction()" class="p-3 text-white rounded-lg" style="background-color:#0048AE">Set Deduction</button>
                        <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <SuccessfulModal
    v-show="successModal"
    @click="closeSuccessModal"
    :message="message"
    />
    <ErrorModal
    v-show="errorModal"
    @click="closeErrorModal"
    :message="message"
    />
</div>
</template>

<script>
import axios from 'axios';
import SuccessfulModal from '../../LandingPages/SuccessfulModal.vue';
import ErrorModal from '../ErrorModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        SuccessfulModal,
        ErrorModal
    },
    data() {
        return {
            userId: localStorage.getItem('userId'),
            currentPrice:"",
            deduction:"",
            deductionValidity: "",
            currentPriceValidity: "",
            isLoading:false,
            errorModal: false,
            successModal: false,
            message: "",
            package:"",
            setPrice: "",
            packageValidity: "",
            setPriceValidity : "",
            pricePerKm: [],
            token : localStorage.getItem("token")
        }
    },

    mounted() {
        // this.getPricePerKm();
    },
    methods: {
        closeSuccessModal() {
            this.successModal = false;
        },
        closeErrorModal() {
            this.errorModal = false
        },
        

        updateDeduction() {
             if (!this.deduction) {
                this.deductionValidity = 'invalid';
                setTimeout(() => {
                    this.deductionValidity = ""
                }, 3000);
            } else {
                this.isLoading = true
                axios({
                method: 'PUT',
                url: `${url}/v1/web/users/config/price/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data : {
                    pricePerKm: this.deduction,
                    packageType: "deduction"
                }
                })
                .then((res) =>{
                    res.json;
                    this.message = "Deduction Successfully Updated"
                    this.successModal = true;
                    this.isLoading = false;
                    this.deduction = "";
                })
                .catch((err)=>{
                    let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
                })
            }
            
        },

    }
}
</script>